@file:OptIn(ExperimentalSerializationApi::class)

package fr.frux.shared.dto

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/** Rôle d'une personne sur un jardin collectif (ADR 0037). */
@Serializable
enum class SiteMemberRoleDto { MANAGER, GARDENER, GARDENER_SELF }

@Serializable
enum class SiteMemberStatusDto { PENDING, ACTIVE }

/** Rôles qu'une personne peut demander : `GARDENER_SELF` s'obtient sans demande. */
@Serializable
enum class SiteRequestedRoleDto { MANAGER, GARDENER }

/**
 * Lien de l'appelant avec un jardin. Les défauts sont les valeurs les moins privilégiées : avec
 * `coerceInputValues`, une valeur future inconnue d'un client publié retombe dessus. `@EncodeDefault` :
 * `encodeDefaults = false` côté serveur omettrait sinon `GARDENER_SELF` et `PENDING`, qui doivent
 * rester explicites.
 */
@Serializable
data class SiteMembershipDto(
    @EncodeDefault
    val role: SiteMemberRoleDto = SiteMemberRoleDto.GARDENER_SELF,
    @EncodeDefault
    val status: SiteMemberStatusDto = SiteMemberStatusDto.PENDING,
)

@Serializable
data class SiteRoleRequest(
    val role: SiteRequestedRoleDto,
    val message: String? = null,
)

@Serializable
data class SiteMemberDto(
    val userId: Long,
    val username: String? = null,
    // @EncodeDefault : le serveur n'encode pas les défauts, rôle et statut doivent rester explicites.
    @EncodeDefault
    val role: SiteMemberRoleDto = SiteMemberRoleDto.GARDENER_SELF,
    @EncodeDefault
    val status: SiteMemberStatusDto = SiteMemberStatusDto.PENDING,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val requestedAt: Instant,
)

@Serializable
data class SiteMembersResponse(
    val members: List<SiteMemberDto>,
)

/** Ligne de l'export RGPD : les liens de la personne avec des jardins. */
@Serializable
data class ExportedSiteMembershipDto(
    val siteId: Long,
    val siteName: String,
    val role: SiteMemberRoleDto,
    val status: SiteMemberStatusDto,
    val message: String? = null,
    @Serializable(with = InstantEpochMillisSerializer::class)
    val createdAt: Instant,
)
